import React from 'react';
import { BrainIcon, CoffeeIcon, ClockIcon, BatteryLowIcon, AlertCircleIcon } from 'lucide-react';
const ProblemSection = () => {
  const problems = [{
    icon: <BrainIcon className="w-8 h-8 text-indigo-700" data-id="element-227" />,
    title: 'Mental Fog',
    description: 'Struggling to maintain focus and clarity during critical decisions'
  }, {
    icon: <CoffeeIcon className="w-8 h-8 text-indigo-700" data-id="element-228" />,
    title: 'Caffeine Dependency',
    description: 'Relying on stimulants just to get through the day'
  }, {
    icon: <ClockIcon className="w-8 h-8 text-indigo-700" data-id="element-229" />,
    title: 'Racing Mind at Night',
    description: "Unable to quiet your thoughts when it's time to rest"
  }, {
    icon: <BatteryLowIcon className="w-8 h-8 text-indigo-700" data-id="element-230" />,
    title: 'Chronic Fatigue',
    description: 'Waking up exhausted, regardless of hours spent in bed'
  }, {
    icon: <AlertCircleIcon className="w-8 h-8 text-indigo-700" data-id="element-231" />,
    title: 'Performance Anxiety',
    description: 'Constant worry about losing your competitive edge'
  }];
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-232">
      <div className="container mx-auto px-4" data-id="element-233">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6" data-id="element-234">
          The Executive Sleep Crisis
        </h2>
        <p className="text-lg md:text-xl text-gray-700 text-center max-w-3xl mx-auto mb-12" data-id="element-235">
          In today's high-pressure business environment, quality sleep isn't a
          luxury—it's a competitive necessity. Yet for many executives, it
          remains frustratingly elusive.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-236">
          {problems.map((problem, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md" data-id="element-237">
              <div className="mb-4" data-id="element-238">{problem.icon}</div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-239">{problem.title}</h3>
              <p className="text-gray-600" data-id="element-240">{problem.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default ProblemSection;